<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Wall of Shame</span>
        <span class="font-weight-light"> - Really Bad Drivers</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <router-view />

    </v-content>
    <new-entry/>
    <div class="overflow-hidden">
      <div class="text-center mb-2">
        <v-btn
          text
          color="deep-purple"
          @click="showNav = !showNav"
        >
          Toggle Nav
        </v-btn>
      </div>

      <v-bottom-navigation
        app
        fixed
        grow
        color="indigo"
      >
        <v-btn to="/">
          <v-icon>mdi-wall</v-icon>
        </v-btn>

        <v-btn to="leaderboard">
          <v-icon>mdi-format-list-bulleted-triangle</v-icon>
        </v-btn>

        <v-btn @click="toggleForm">
          <span></span>
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn to="search">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn to="profile">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';
import NewEntry from './views/NewEntry';
import { mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    NewEntry,
  },
  data: () => ({
    //
  }),
  methods: {
    ...mapActions({
      toggle: 'toggleForm', // map `this.toggle()` to `this.$store.dispatch('toggleForm')`
    }),
    toggleForm() {
      this.toggle();
    },
  },
};
</script>
